import React from 'react';
import { useNavigate } from 'react-router-dom';

import Icone from 'Component/Icone';
import { useAppSelector } from 'Store';
import { useRecuperarFechamentosDeFolhaQuery } from 'View/Service/Default/FechamentosDeFolha';

const Folhas = (): React.ReactElement => {
  const navegacao = useNavigate();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const { data: { fechamentos_de_folha } = {} } =
    useRecuperarFechamentosDeFolhaQuery({
      options: { usuario_id: usuario?.id, assinado: 0 },
    });

  return (
    <React.Fragment>
      {fechamentos_de_folha?.length ? (
        <div
          className="alert alert-danger cursor-pointer"
          onClick={() => navegacao('/fechamentos-de-folha/historico')}
        >
          <strong className="me-3">
            <Icone nome="exclamation-circle-fill" /> Atenção
          </strong>
          Existem arquivos do <strong>fechamento de folha</strong> para você
          assinar!
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Folhas;
